import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function Aprenderas() {
  const modules = [{
    num: '01',
    text: <>
          <strong data-id="element-81">Por qué el reflujo vuelve siempre:</strong> la causa real que
          los antiácidos no atacan y que nadie te explicó en términos simples.
        </>
  }, {
    num: '02',
    text: <>
          <strong data-id="element-82">El mapa de tus detonantes personales:</strong> cómo
          identificar exactamente qué dispara tu acidez, no la de otra persona.
        </>
  }, {
    num: '03',
    text: <>
          <strong data-id="element-83">El protocolo de 72 horas paso a paso:</strong> la secuencia
          exacta del Protocolo de Reprogramación Digestiva™ con instrucciones
          diarias.
        </>
  }, {
    num: '04',
    text: <>
          <strong data-id="element-84">Cómo dormir sin que el ácido suba:</strong> la rutina nocturna
          anti-reflujo que elimina los episodios nocturnos.
        </>
  }, {
    num: '05',
    text: <>
          <strong data-id="element-85">Alimentos aliados vs. alimentos trampa:</strong> la lista
          definitiva con explicación de por qué cada uno afecta tu estómago.
        </>
  }, {
    num: '06',
    text: <>
          <strong data-id="element-86">El error que comete el 80% de las personas:</strong> la
          creencia sobre el ácido que agrava el problema en lugar de resolverlo.
        </>
  }, {
    num: '07',
    text: <>
          <strong data-id="element-87">Reflujo y estrés — la conexión que nadie te cuenta:</strong>{' '}
          cómo el sistema nervioso dispara la acidez y qué hacer al respecto.
        </>
  }, {
    num: '08',
    text: <>
          <strong data-id="element-88">Cómo cenar sin pagar el precio de noche:</strong> un método
          simple para las comidas nocturnas sin despertar con ardor.
        </>
  }, {
    num: '09',
    text: <>
          <strong data-id="element-89">Protocolo de emergencia anti-agrura:</strong> qué hacer en los
          próximos 10 minutos cuando el ardor aparece de golpe.
        </>
  }, {
    num: '10',
    text: <>
          <strong data-id="element-90">Hernia hiatal y gastritis — aclarando el panorama:</strong>{' '}
          qué cambia en el protocolo si tenés alguna de estas condiciones.
        </>
  }, {
    num: '11',
    text: <>
          <strong data-id="element-91">Cómo reducir la medicación gradualmente:</strong> el proceso
          seguro para disminuir el omeprazol sin que el reflujo se dispare.
        </>
  }, {
    num: '12',
    text: <>
          <strong data-id="element-92">Mantenimiento a largo plazo:</strong> cómo sostener los
          resultados después de las 72 horas y no volver al punto de partida.
        </>
  }, {
    num: '13',
    text: <>
          <strong data-id="element-93">
            El Protocolo de Reprogramación Digestiva™ en formato resumen:
          </strong>{' '}
          la guía rápida para aplicar todo el método sin releer el libro entero
          cada vez.
        </>,
    fullWidth: true
  }];
  return <section id="aprenderas" className="py-[100px] bg-[radial-gradient(ellipse_80%_40%_at_50%_100%,rgba(224,122,80,0.12)_0%,transparent_60%),linear-gradient(180deg,#120806_0%,#1a0f08_100%)]" data-id="element-94">
      <div className="container-custom" data-id="element-95">
        <SectionHeader eyebrow="Contenido del ebook" title={<>
              Todo lo que <span className="text-gold" data-id="element-97">vas a aprender</span>
              <br data-id="element-98" />
              con el protocolo
            </>} description="13 módulos de contenido práctico, directo y aplicable desde el primer día." data-id="element-96" />

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[1px] bg-gold/10 border border-gold/10 rounded-[12px] overflow-hidden mt-[60px]" data-id="element-99">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: idx % 2 * 0.1
        }} className={`bg-[#1e0e08] p-[22px_24px] flex gap-3.5 items-start transition-colors duration-300 hover:bg-[#281408] ${mod.fullWidth ? 'sm:col-span-2' : ''}`} data-id="element-100">
              <span className="font-display text-[13px] text-gold font-bold shrink-0 min-w-[22px] mt-px" data-id="element-101">
                {mod.num}
              </span>
              <p className="text-[14px] text-gray-light leading-[1.5]" data-id="element-102">
                {mod.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}